import React from 'react';
import AttachmentIcon from '@mui/icons-material/Attachment';

const FileMessageAttachment = () => (<AttachmentIcon />);

export default FileMessageAttachment;
